<template>
  <div class="contact">
    <div class="contactTitle">
      <img src="../assets/contact/contactTitle.png" />
    </div>
    <div class="content">
      <img style="width: 161px; height: 161px; background: #d32e39" src="../assets/other/ercode.jpg"/>
      <div class="contactUs">
        <div
          style="
            font-size: 42px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #000000;
          "
        >
          0371-55238625
        </div>
        <div
          style="
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
            margin:30px 0 26px 0
          "
        >
          邮箱：hnkhcyy1@163.com
        </div>
        <div
          style="
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
          "
        >
          地址：河南省济源市高新区科教街涌盛产业园双子楼A/B座
        </div>
      </div>
    </div>
    <div class="map">
        <baidu-map 
        class="bm-view" 
        :center="{lng: 112.604942, lat: 35.046368}" 
        :zoom="15" 
        :scroll-wheel-zoom="true"
         key=""
         ak="YOUR_APP_KEY">
          <bm-marker :position="{lng: 112.604942, lat: 35.046368}" 
        :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      <bm-label content="科慧产业园区" 
          :labelStyle="{ fontSize : '14px',color:'#222',border:'0px',padding:'10px 15px',left:'-43px'}" 
          :offset="{width: -47, height: 30}"/>
    </bm-marker>
       
        
          
       </baidu-map>

  
    </div>
  </div>
</template>

<script>

import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
// import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'




export default {
  data() {
    return {
        center: {lng:112.604942, lat: 35.046368},
       

    };
  },
  components: {
    BaiduMap
  },
  methods:{
    
  },
  mounted(){
     
    //   this.center = new BMap.Point(this.center.lng, this.center.lat)

  }
};
</script>

<style lang="less" scoped>
.contact {
  //   text-align: center;
  padding-top: 81px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .content {
    display: flex;
    margin-top: 70px;
    .contactUs {
      margin-left: 52px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
  }
  .map{
      margin-top:87px;
      .bm-view {
 width: 1200px;
height: 421px;
background: black;
.BMapLabel{
  border:0px !important;
  background: #fff !important;
  padding:10px 20px !important;


}
}
  }
}
</style>